module.exports = __webpack_public_path__ + "static/media/delta-building.a7cbc92d.jpg";